import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * A base UI service for components. This service allows sub-components to communicate the components
 * without maintaining a direct reference.
 */
@Injectable({
  providedIn: 'root'
})
export class BaseComponentUIService {
  /** A delete request RXJS subject */
  public deleteRequestSubject$ = new Subject<string>();

  /** An edit request RXJS subject */
  public editRequestSubject$ = new Subject<string>();

  /** A clone request RXJS subject */
  public cloneRequestSubject$ = new Subject<string>();

  /**
   * Broadcast a clone request
   * @param id - The ID of the object associated with the request
   */
  public cloneRequest(id: string) {
    this.cloneRequestSubject$.next(id);
  }

  /**
   * Broadcast a delete request
   * @param id - The ID of the object associated with the request
   */
  public deleteRequest(id: string) {
    this.deleteRequestSubject$.next(id);
  }

  /**
   * Broadcast an edit request
   * @param id - The ID of the object associated with the request
   */
  public editRequest(id: string) {
    this.editRequestSubject$.next(id);
  }

  /**
   * Subscribe to an RXJS subject
   * @param subjectName - The name of the subject to subscribe to
   * @param callback - The method to callback
   */
  public subscribe(
    subjectName: string,
    callback: (result: any) => Promise<void> | void
  ) {
    this[subjectName].subscribe(callback);
  }
}
